import { render, staticRenderFns } from "./index.html?vue&type=template&id=024d4528&scoped=true&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=024d4528&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=024d4528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d4528",
  null
  
)

export default component.exports